import React from 'react';
import { IDelivery } from "types/backend_models/deliveries/IDelivery";
import BasicField from 'components/content/shared/fields/BasicField';
import ContainerSectionTitle from 'components/content/shared/other/ContainerSectionTitle';
import { toDateString } from 'functions/formatters/date';

interface IProps
{
	delivery: IDelivery | null
}

export function DeliveryDetailInfoOne(props: IProps)
{
	const labelClassName = "col-m-6";
	const valueClassName = "col-m-6";

	// console.log(colors);

	if (!props.delivery) {
		return null;
	} else {
		// const statusColor = GetDeliveryStatusColorClass(props.delivery.statusId);

		return (
			<>
				<ContainerSectionTitle>Delivery Info</ContainerSectionTitle>
				<BasicField
					label="Delivery Number"
					value={props.delivery.id}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				<BasicField
					label="Order Number"
					value={props.delivery.orderNumber}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				{/* <BasicField
					label="Customer"
					value={props.delivery.account}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/> */}
				<BasicField
					label="Shipping Address"
					value={props.delivery.address}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				<BasicField
					label="Shipping Contact"
					value={props.delivery.contact}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				<BasicField
					label="Shipping Date"
					value={toDateString(props.delivery.shippingDate)}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/> 
			</>
		);
	}
}

/* UNCOMMENT IF EVER NEEDED AGAIN
export function DeliveryDetailInfoTwo(props: IProps)
{
	// console.log(colors);

	const labelClassName = "col-m-6 col-l-9";
	const valueClassName = "col-m-6 col-l-3";

	if (!props.delivery) {
		return null;
	} else {
		// const statusColor = GetDeliveryStatusColorClass(props.delivery.statusId);

		return (
			<>
				<ContainerSectionTitle>Additional info</ContainerSectionTitle>
				<BasicField
					label="Number of colli"
					value={props.delivery.numberOfColli}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				<BasicField
					label="Net weight"
					value={props.delivery.netWeight}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				<BasicField
					label="Gross weight"
					value={props.delivery.grossWeight}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				<BasicField
					label="Airway bill number"
					value={props.delivery.airwayBillNumber}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				<BasicField
					label="Packing List Report Id"
					value={props.delivery.packingListReportId}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				<BasicField
					label="Comm Inv Rep Id"
					value={props.delivery.commercialInvoiceReportId}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
			</>
		);
	}
}
*/